// Custom cursor. A small espresso dot follows the pointer with a slight
// trailing ease and turns coral over clickable elements. No scaling.
//
// Fine-pointer (mouse) devices only — touch/coarse devices keep their native
// behaviour and the native cursor is never hidden there. The colour change is
// CSS-driven; this module only tracks position and toggles classes.

export default function cursor() {
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!fine.matches) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Elements that switch the dot to its coral "hover" state.
    const CLICKABLE = 'a, button, [role="button"], input, textarea, select, label, summary, [data-cursor]';

    const dot = document.createElement('div');
    dot.className = 'cursor';
    dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(dot);
    document.documentElement.classList.add('has-custom-cursor');

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let x = targetX;
    let y = targetY;
    let raf = null;

    const render = () => {
        // Lerp toward the pointer for a slight trail; snap when reduced motion.
        const ease = reduceMotion ? 1 : 0.2;
        x += (targetX - x) * ease;
        y += (targetY - y) * ease;
        dot.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;

        if (Math.abs(targetX - x) > 0.1 || Math.abs(targetY - y) > 0.1) {
            raf = requestAnimationFrame(render);
        } else {
            raf = null;
        }
    };

    const requestRender = () => {
        if (raf === null) raf = requestAnimationFrame(render);
    };

    window.addEventListener('pointermove', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        targetX = event.clientX;
        targetY = event.clientY;
        dot.classList.add('is-visible');

        const target = event.target;
        const hovering = target instanceof Element && target.closest(CLICKABLE);
        dot.classList.toggle('is-hover', Boolean(hovering));

        requestRender();
    }, { passive: true });

    // Hide the dot when the pointer leaves the document.
    document.addEventListener('mouseleave', () => dot.classList.remove('is-visible'));
    document.addEventListener('mouseenter', () => dot.classList.add('is-visible'));
}
